"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const addUser_1 = require("./addUser");
const addCredentials_1 = require("./addCredentials");
function storeToken({ refreshToken, uid, name, email, domainId, providerId, role, googleAuthRefreshToken, }, password) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return app_1.app.auth.currentUser.getIdToken(true).then((token) => __awaiter(this, void 0, void 0, function* () {
                // call ppl utils for entry in firestore
                const providerIds = providerId === 'password' ? { email: uid } : { google: uid };
                const userData = yield addUser_1.default({
                    name,
                    email,
                    providerIds,
                    permissions: [
                        {
                            domainId,
                            role
                        }
                    ],
                    password,
                    googleAuthRefreshToken
                });
                // role will always be passed as paramter to the function
                // const role = await getUserRole({ id: userData.id, domainId });
                const credentials = {
                    name,
                    token,
                    refreshToken,
                    googleAuthRefreshToken,
                    domainId,
                    uid: userData.id,
                    role,
                    email,
                    providerId
                };
                addCredentials_1.default({ credentials, remember: true });
                return 'Credentials set in local store';
            }));
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = storeToken;
//# sourceMappingURL=storeToken.js.map